import {
  getGetMappaCatalogoLivelliQueryOptions,
  getMappaCatalogoLivelli,
} from '@framework/api-client/api/users/mappa-catalogo-livelli-controller/mappa-catalogo-livelli-controller.ts';
import { type MappaCatalogoLivelliDTO } from '@framework/api-client/api/users/schemas/mappaCatalogoLivelliDTO.ts';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form/inputs/AsyncSelectInput.tsx';

export interface ILayerCatalogSearchSelectProps
  extends IBaseAsyncSelectInputProps {
  /**
   * Invocata alla selezione col DTO completo del catalogo,
   * o `null` alla cancellazione.
   */
  onAfterChange?: (catalog: MappaCatalogoLivelliDTO | null) => void;
}

/**
 * AsyncSelect riutilizzabile per la selezione di un catalogo livelli.
 * Carica i dati dall'API (endpoint paginato) con ricerca per denominazione,
 * quindi non è limitato ai primi N risultati. Restituisce il DTO completo
 * tramite `onAfterChange`.
 */
export function LayerCatalogSearchSelect(
  props: ILayerCatalogSearchSelectProps,
) {
  const { onAfterChange, ...otherProps } = props;
  return (
    <AsyncSelectInput
      {...otherProps}
      queryFn={getMappaCatalogoLivelli}
      queryOptions={getGetMappaCatalogoLivelliQueryOptions}
      initialParams={{ ordinamenti: ['denominazione'] }}
      searchByField="denominazione"
      responseMeta={response => ({
        shown: response?.dati?.length ?? 0,
        total: response?.meta?.totale ?? 0,
      })}
      asOption={(catalog: MappaCatalogoLivelliDTO) => ({
        value: String(catalog.id),
        label: catalog.denominazione ?? String(catalog.id),
      })}
      onAfterChange={(_value, selected) =>
        onAfterChange?.(
          (selected as MappaCatalogoLivelliDTO | undefined) ?? null,
        )
      }
    />
  );
}
